import { useEffect } from 'react';
import { useDispatch, useIntervalDate, useSelector, useToggleState } from '@lingoda/hooks';
import { Loader } from '@lingoda/ui';
import { fetchMe, isAuthStatusUnauthenticatedSelector, userSelector } from '@lingoda/auth';
import { getMinutes } from '@lingoda/dates';
import { useLogout } from '@lingoda/students';
import type { PropsWithChildren } from 'react';

export const UserBlock = ({ children }: PropsWithChildren<unknown>) => {
    const user = useSelector(userSelector);
    const isUnauthenticatedUser = useSelector(isAuthStatusUnauthenticatedSelector);
    const performLogout = useLogout();
    const [loaded, setLoaded] = useToggleState(false);

    useFetchMeRefetch();

    useEffect(() => {
        if (user) {
            if (!user.studentId) {
                void performLogout();
            } else {
                setLoaded();
            }
        }
    }, [user, performLogout, setLoaded]);

    if (isUnauthenticatedUser || loaded) {
        return <>{children}</>;
    }

    return <Loader />;
};

const useFetchMeRefetch = () => {
    const dispatch = useDispatch();
    const now = useIntervalDate('minute');

    // Refetch dismissedWidgets after possible class
    const nowMinutes = getMinutes(now);
    useEffect(() => {
        if (nowMinutes === 2) {
            dispatch(fetchMe());
        }
    }, [dispatch, nowMinutes]);
};
